"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const mainData_1 = __importDefault(require("./mainData"));
exports.default = (0, vue_1.defineComponent)({
    name: 'AdditionalGuarantor',
    components: {
        ListView: ListView_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {
                // layout: 'horizontal'
                },
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    },
                    {
                        prop: 'build',
                        name: '新增',
                        type: 'primary'
                    },
                    {
                        prop: 'delete',
                        name: '删除',
                        type: 'danger',
                        disabled() {
                            return mainData_1.default.$module.choice.getId().length === 0;
                        }
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'change',
                            name: '编辑'
                        }
                    ]
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    mounted() {
        this.mainData.$reloadData({});
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        }
    }
});
